import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad } from '../components/';
import { Dictionary } from '../Dati';
import { CampoNumero } from '../components/';


interface IInputPercentualeProps extends Dati.IBaseProps {
    Etichetta: any;
    Valore: number;
    Minimo?: number;
    Massimo?: number;
    Precisione?: number;
    ValoreNeutro?: number;
    Disabilitato?: boolean;
    OnChangeAppendice?: (e: React.FormEvent<any> | string, valore: any, label?: string, fieldTypeId?: number, elementGroup?: any) => any;
}

export class InputPercentuale extends BasePureComponent<IInputPercentualeProps, {}> {
    private _Valore: number = 0;
    constructor(props: any) {
        super(props);
        this._Valore = this.props.Valore;
    }

    private OnAggiorna(e: React.FormEvent<any>): void {
        this._Valore = e.currentTarget.value;
        this.props.OnChange(this.props.Name, this._Valore);
    }

    public render() {
        this._Valore = this.props.Valore;
        let etichetta: any = "";
        if (typeof (this.props.Etichetta == "string")) {
            etichetta = <label>{this.props.Etichetta}</label>;
        } else {
            etichetta = this.props.Etichetta;
        }
        return <div style={{ minHeight: 88 }} className={this.props.CSS != undefined ? this.props.CSS : ""}>
            {etichetta}
            <div className="kt-input-icon kt-input-icon--right">
                <CampoNumero
                    Valore={this._Valore}
                    Name={this.props.Name}
                    Id={this.props.Id}
                    OnChange={(e) => this.OnAggiorna((e as React.FormEvent<any>))}
                    OnChangeAppendice={this.props.OnChangeAppendice}
                    OnBlur={this.props.OnBlur}
                    Scrittura={this.props.Scrittura}
                    CSS="form-control kt-input"
                    Icona="fa fa-percentage"
                    Minimo={this.props.Minimo}
                    Massimo={this.props.Massimo}
                    ValoreNeutro={this.props.ValoreNeutro}
                    BarraLimiti={this.props.Massimo != undefined}
                    Precisione={this.props.Precisione}
                    Disabilitato={this.props.Disabilitato}
                />
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/InputPercentuale.tsx